<template>
  <div class="app-wrapper">
    <!--    <top></top>-->
    <!--    &lt;!&ndash; nav &ndash;&gt;-->
    <!--    <nav-logo></nav-logo>-->
    <top_nav></top_nav>
<!--    <div :class="['main-container', logoHeaderOption(this.key, 'style')]">-->
    <div class="main-container">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <router-view :key="key"/>
        </keep-alive>
      </transition>
    </div>
    <div class="tabBox" v-show="key== '/index'">
      <div class="w">
        <iframe name="myiframe" ref="myiframe" id="myiframe" :src="query" frameborder="0" width="100%" :height="1850" @load="oniframeload()"></iframe>
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="供给大厅" name="first">
                <iframe id="first" :src="query" frameborder="0" width="100%" :height="980"></iframe>
            </el-tab-pane>
            <el-tab-pane label="需求大厅" name="first1">
                <iframe id="first1" :src="query" frameborder="0" width="100%" :height="980"></iframe>
            </el-tab-pane>
        </el-tabs> -->
      </div>
    </div>
    <foot_nav></foot_nav>
    <!--    <foot></foot>-->
        <!-- <feedback></feedback> -->
  </div>
</template>

<script>
    import top_nav from '@/components/top_nav'
    import foot_nav from '@/components/foot_nav'
    import feedback from '@/components/layout/feedback'
    import {mapState,mapGetters} from 'vuex'
    import {logoHeaderOption} from '@/utils'

    export default {
        name: 'Layout',
        components: {
            top_nav,
            foot_nav,
            feedback
        },
        computed: {
            ...mapState({}),
            ...mapGetters(['EncodeUserInfo']),
            key() {
              // console.log('this.$route.path',this.$route.path)
                return this.$route.path
            },
            query(){
              let url = process.env.NODE_ENV=='testing'?'https://cs-info.hbgyl.com.cn/homeList':'https://info.hbgyl.com.cn/homeList'
              if(this.EncodeUserInfo){
                url=url+'?code='+ this.EncodeUserInfo
              }
              return url
            }
        },
        watch:{

          // '$route.path': {
          //     immediate: true, // 如果需要在监听时立即触发，则设置为true
          //     handler(newPath, oldPath) {
          //       // 路由发生变化时的处理逻辑
          //       if(newPath == '/index'){
          //         this.$nextTick(() => {
          //             // this.oniframeload()
          //         })
                  
          //       }
          //   }
          // }
        },
      
        data() {
            return {
                logo: '',
                // activeName: 'first',
              
            }
        },
        created() {
          
        },
        mounted(){

        },
        methods: {
            logoHeaderOption,
            oniframeload(){
                let origin =process.env.NODE_ENV=='testing'?'https://cs-www.hbgyl.com.cn/':'https://www.hbgyl.com.cn/'
                let obj= {
                    code:this.EncodeUserInfo
                }
                // let iframeWin = this.$refs.myiframe;
                // console.log('iframeWin===',iframeWin);
                // iframeWin.contentWindow.postMessage(JSON.stringify(obj),origin);
            }
        }
    }
</script>

<style scoped lang='less'>
  .main-container {
    /* margin-top: -40px; */
    /* height: calc(100vh - 209px); */
  }
    .tabBox{
  background-color: #fff;
  position: relative;
  /deep/ .el-tabs__nav{
    width: 100%;
    box-shadow: 0px 0px 40px 0px rgba(31,69,147,0.2);
  }
  /deep/ .is-active{
    color: #0256FF;
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  /deep/ .el-tabs__item:hover{
    color: #0256FF;
  }
  /deep/.el-tabs__active-bar{
    background-color: #0256FF;
  }
  /deep/ .el-tabs__content{
    overflow:visible;
  }
  /deep/ .el-tabs__item{
    text-align: center;
    width:50%;
    height: 24px;
    font-size: 18px;
    // font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: 700;
    line-height: 24px;
    padding-top: 40px;
    padding-bottom: 40px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue